import React from 'react';
import { ChevronDown, Filter } from 'lucide-react';

/**
 * Shared form-control styling for the modernised CRM list pages (Leads,
 * Clients, Tasks, Community, Fires, Questions): rounded-xl, hairline border,
 * soft shadow, red focus ring. Pad the left/right yourself (search inputs
 * add an icon gutter, plain fields use px-3).
 */
export const FIELD_CLASS =
  'w-full rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 py-3 text-sm text-gray-900 dark:text-white placeholder-gray-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent';

export const LABEL_CLASS = 'block text-sm font-medium mb-1.5 text-gray-700 dark:text-gray-300';

export const TH_CLASS =
  'px-2 sm:px-4 py-3 text-left text-[11px] font-semibold uppercase tracking-wider text-gray-500 dark:text-gray-400';

/**
 * Select styled like the Leads stage filter: funnel icon on the left, custom
 * chevron on the right. Pass `icon={false}` for a plain form select.
 */
export const FilterSelect = ({ className = '', icon = true, children, ...props }) => (
  <div className={`relative shrink-0 ${className}`}>
    {icon && (
      <Filter className="pointer-events-none absolute left-3.5 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" aria-hidden />
    )}
    <select
      {...props}
      className={`${FIELD_CLASS} appearance-none ${icon ? 'pl-10' : 'pl-3'} pr-9 font-medium text-gray-700 dark:text-gray-200 cursor-pointer`}
    >
      {children}
    </select>
    <ChevronDown className="pointer-events-none absolute right-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" aria-hidden />
  </div>
);
